var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28577 3.21429V13.5H3.8572V16.7747L4.90184 15.9307L7.93548 13.5H14.1429V3.21429H1.28577ZM2.57148 4.50001H12.8572V12.2143H7.4932L7.31255 12.3551L5.14291 14.0824V12.2143H2.57148V4.50001ZM15.4286 5.78572V7.07144H18.0001V14.7857H15.4286V16.6539L13.0783 14.7857H8.25691L6.64977 16.0714H12.6361L16.7143 19.3462V16.0714H19.2858V5.78572H15.4286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.7d77aab333c6c713e130ef18169268ff.svg";
export { ForwardRef as ReactComponent };